"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var regexTrimSpaces = /^\s*|\s*$/g;
var regexMultipleSpaces = /\s{2,}/g;
var _jsxToString = function jsxToString(component) {
  var children = component !== null && component !== void 0 && component.props ? component.props.children : component;
  if (typeof children === 'string') {
    return children;
  }
  if (Array.isArray(children)) {
    return _react.Children.toArray(children).map(_jsxToString).join(' ');
  }
  return children ? _jsxToString(children) : '';
};
var _default = exports["default"] = function _default(component) {
  return _jsxToString(component).replace(regexTrimSpaces, '').replace(regexMultipleSpaces, ' ');
};